/**
 * @generated SignedSource<<328200ce83c3438b58f087d9b76abac1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type JobScheduleStatusEnum = "AHEAD" | "DELAYED" | "ON_TIME";
export type JobStatusEnum = "CANCELLED" | "COMPLETED" | "RUNNING" | "SCHEDULED";
import { FragmentRefs } from "relay-runtime";
export type SurgeryCardFragment_surgery$data = {
  readonly actualStartTime: any | null | undefined;
  readonly actualStopTime: any | null | undefined;
  readonly durations: {
    readonly delayAfterMinutes: number | null | undefined;
    readonly dynamicDurationMinutes: number | null | undefined;
  } | null | undefined;
  readonly estimatedStartTime: any | null | undefined;
  readonly estimatedStopTime: any | null | undefined;
  readonly id: string;
  readonly location: {
    readonly name: string | null | undefined;
  } | null | undefined;
  readonly name: string | null | undefined;
  readonly patientMrn: string | null | undefined;
  readonly plannedStart: any | null | undefined;
  readonly plannedStop: any | null | undefined;
  readonly scheduleStatus: JobScheduleStatusEnum | null | undefined;
  readonly status: JobStatusEnum | null | undefined;
  readonly turnover: {
    readonly actualStartTime: any | null | undefined;
    readonly actualStopTime: any | null | undefined;
    readonly durations: {
      readonly dynamicDurationMinutes: number | null | undefined;
    } | null | undefined;
    readonly estimatedStartTime: any | null | undefined;
    readonly estimatedStopTime: any | null | undefined;
    readonly id: string;
    readonly name: string | null | undefined;
    readonly plannedStart: any | null | undefined;
    readonly plannedStop: any | null | undefined;
    readonly scheduleStatus: JobScheduleStatusEnum | null | undefined;
    readonly status: JobStatusEnum | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"InfoBoxJobFragment_job">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"DemoHeader_surgery" | "InfoBoxJobFragment_job" | "SurgeryDetailsDrawer_surgery">;
  readonly " $fragmentType": "SurgeryCardFragment_surgery";
};
export type SurgeryCardFragment_surgery$key = {
  readonly " $data"?: SurgeryCardFragment_surgery$data;
  readonly " $fragmentSpreads": FragmentRefs<"SurgeryCardFragment_surgery">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "plannedStart",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "plannedStop",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimatedStartTime",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimatedStopTime",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualStartTime",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualStopTime",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "scheduleStatus",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dynamicDurationMinutes",
  "storageKey": null
},
v11 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "InfoBoxJobFragment_job"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SurgeryCardFragment_surgery",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    (v3/*: any*/),
    (v4/*: any*/),
    (v5/*: any*/),
    (v6/*: any*/),
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "patientMrn",
      "storageKey": null
    },
    (v8/*: any*/),
    (v9/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Location",
      "kind": "LinkedField",
      "name": "location",
      "plural": false,
      "selections": [
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Durations",
      "kind": "LinkedField",
      "name": "durations",
      "plural": false,
      "selections": [
        (v10/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "delayAfterMinutes",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Turnover",
      "kind": "LinkedField",
      "name": "turnover",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/),
        (v3/*: any*/),
        (v4/*: any*/),
        (v5/*: any*/),
        (v6/*: any*/),
        (v7/*: any*/),
        (v8/*: any*/),
        (v9/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Durations",
          "kind": "LinkedField",
          "name": "durations",
          "plural": false,
          "selections": [
            (v10/*: any*/)
          ],
          "storageKey": null
        },
        (v11/*: any*/)
      ],
      "storageKey": null
    },
    (v11/*: any*/),
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DemoHeader_surgery"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SurgeryDetailsDrawer_surgery"
    }
  ],
  "type": "Surgery",
  "abstractKey": null
};
})();

(node as any).hash = "55ac9383c74ddc0b1dbac975be70d5be";

export default node;
